import { render } from "./TransferWizardFullscreenModal.vue?vue&type=template&id=ebb283c0"
import script from "./TransferWizardFullscreenModal.vue?vue&type=script&lang=js"
export * from "./TransferWizardFullscreenModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__